var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import { html } from "../../tools/utilities/component";
import { formatMoney, getFormat, t } from '@process-creative/slate-theme-tools';
var SEL_FREE_SHIPPING = '.c-shipping-progress';
var IS_HIDDEN = 'is-hidden';
export var shippingProgressBarCreate = function shippingProgressBarCreate(minSpendAttr, subtotal) {
  if (!minSpendAttr) return '';
  var minSpend = parseInt(minSpendAttr);
  if (minSpend == 0) return ''; // Spend progress

  var spendProgress = subtotal < minSpend ? subtotal / minSpend * 100 : 100;
  var remaining = subtotal < minSpend ? minSpend - subtotal : 0;
  var shippingLabel = t('cart.free_shipping_unlocked');

  if (remaining > 0) {
    shippingLabel = t('cart.free_shipping_remaining', {
      remaining: formatMoney(remaining, getFormat('', 'money_format')).replace('.00', '')
    });
  }

  return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  <div class=\"c-shipping-progress\">\n    <p class=\"c-shipping-progress__label\">\n      ", "\n    </p>\n\n    <div class=\"c-shipping-progress__progress\">\n      <span class=\"c-shipping-progress__progress-bar\"></span>\n      <span\n        class=\"c-shipping-progress__progress-fill ", "\"\n        style=\"width: ", "%\"\n      ><span>\n    </div>\n  </div>\n"])), shippingLabel, spendProgress >= 100 ? 'is-full' : '', spendProgress);
}; // GET Location

$.get("https://ipapi.co/json", function (Response) {
  if (Response.country != 'AU') {
    $(SEL_FREE_SHIPPING).addClass(IS_HIDDEN);
  }
});